<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">정품 보증 기간 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 서비스에 사용되는 보증 기간을 설정합니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        아래 설정 타입에 따라 정품 코드 발급시 보증 기간이 등록되게 됩니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        '정품 인증 코드 생성' 메뉴에서 개별 상품에 대해 기간 변경은 가능하오니 참고하세요.
      </p>

      <form name="warrantyPeriodForm" action method class="mt-10">
        <v-radio-group v-model="payload.cert_duration_type" class="mt-0 ml-2" @change="changeRadio">
          <div class="raudio">
            <v-radio :id="AUTH_SERVICE.ACTIVATED" :value="AUTH_SERVICE.ACTIVATED" name="warrantyType" style="display: inline;"></v-radio>
            <label :for="AUTH_SERVICE.ACTIVATED" class="textVerticalAlign">고객 정품 인증일 기준</label>
            <v-col sm="2" md="2" class="d-inline-block col-auto mr-auto textSize">
              <v-text-field
                :disabled="payload.cert_duration_type !== AUTH_SERVICE.ACTIVATED"
                v-model="duration.activated.count"
                type="number"
                min="1"
                max="999"
                class="durationCountText"
                outlined
                solo
                @keydown="M.checkNumber($event)"
                @keyup="M.replaceDateCount($event, duration.activated.type)"
                @blur="M.replaceDateCount($event, duration.activated.type)"
              ></v-text-field>
            </v-col>

            <v-col class="d-inline-block selectSize" cols="2" sm="2">
              <v-select
                :items="items"
                solo
                outlined
                class="d-inline-block col-auto mr-auto"
                v-model="duration.activated.type"
                @change="initCount(duration.activated)"
                :disabled="payload.cert_duration_type !== AUTH_SERVICE.ACTIVATED"
              ></v-select>
            </v-col>
            <label :for="AUTH_SERVICE.ACTIVATED" class="textVerticalAlign">까지 정품 보증을 지원합니다.</label>
          </div>

          <div class="raudio audioBottom">
            <v-radio :id="AUTH_SERVICE.CREATED" :value="AUTH_SERVICE.CREATED" name="warrantyType" style="display: inline;"></v-radio>
            <label :for="AUTH_SERVICE.CREATED" class="textVerticalAlign">정품 인증 코드 생성일 기준</label>
            <v-col sm="2" md="2" class="d-inline-block col-auto mr-auto textSize">
              <v-text-field
                :disabled="payload.cert_duration_type !== AUTH_SERVICE.CREATED"
                v-model="duration.created.count"
                type="number"
                min="1"
                max="999"
                class="durationCountText"
                outlined
                solo
                @keydown="M.checkNumber($event)"
                @keyup="M.replaceDateCount($event, duration.created.type)"
                @blur="M.replaceDateCount($event, duration.created.type)"
              ></v-text-field>
            </v-col>

            <v-col class="d-inline-block col-auto mr-auto selectSize" cols="2" sm="2">
              <v-select
                :items="items"
                solo
                outlined
                class="d-inline-block"
                v-model="duration.created.type"
                @change="initCount(duration.created)"
                :disabled="payload.cert_duration_type !== AUTH_SERVICE.CREATED"
              ></v-select>
            </v-col>
            <label :for="AUTH_SERVICE.CREATED" class="textVerticalAlign">까지 정품 보증을 지원합니다.</label>
          </div>
        </v-radio-group>
      </form>
    </v-container>

    <div class="row justify-center mt-0">
      <v-btn large color="primary" @click.prevent="saveDuration" class="saveBtn">저장</v-btn>
    </div>
  </div>
</template>

<style scoped>
.saveBtn {
  color: unset;
  text-decoration: none;
  width: 200px;
}
.audio {
  height: 50px;
}

.audioBottom {
  margin-bottom: 0px;
}

.textSize {
  width: 100px;
  padding-right: 0px;
  vertical-align: super;
}

.selectSize {
  width: 115px;
  vertical-align: super;
}

.durationCountText >>> input {
  text-align: left;
}

.textVerticalAlign {
  vertical-align: text-bottom;
}
</style>

<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data: () => ({
    M,
    AUTH_SERVICE,
    items: [
      {
        text: "일",
        value: "d",
      },
      {
        text: "개월",
        value: "m",
      },
      {
        text: "년",
        value: "y",
      },
    ],
    duration: {
      activated: {
        count: "",
        type: "d",
      },
      created: {
        count: "",
        type: "d",
      },
    },
    payload: {
      cert_duration_type: "",
      cert_duration: "",
    },
  }),
  created: async function() {
    /**
     * 데이터 가져오기
     */
    await this.getDuration();
  },
  mixins: [CommonMixin],
  methods: {
    changeRadio: function() {
      //
    },
    /**
     * 데이터 가져오기
     */
    getDuration: async function() {
      let data = await M.api(M.entry("/get/duration"), {});
      if (data) {
        this.payload.cert_duration_type = data.duration_type;
        this.payload.cert_duration = data.duration;
      }
      this.setDisplayDuration();
    },
    /**
     * 셋팅
     */
    setDisplayDuration: function() {
      if (this.payload.cert_duration !== "") {
        let count = this.payload.cert_duration.replace(/[a-z]/gi, "");
        let type = this.payload.cert_duration.replace(/[0-9]/g, "");
        AUTH_SERVICE.CERT_DURATION_TYPE_LIST.forEach((typeName) => {
          if (this.payload.cert_duration_type === typeName) {
            this.duration[typeName].count = count;
            this.duration[typeName].type = type;
          } else {
            this.duration[typeName].count = "";
            this.duration[typeName].type = "d";
          }
        });
      }
    },
    /**
     * 폼체크
     */
    checkPayload: function() {
      let type = this.payload.cert_duration_type;
      if (this.duration[type].count === "") {
        this.alertShow("기준일을 입력하세요.");
        return false;
      }
      return true;
    },
    /**
     * 저장
     */
    saveDuration: async function() {
      if (!this.checkPayload()) {
        return false;
      }
      let type = this.payload.cert_duration_type;
      this.payload.cert_duration = `${this.duration[type].count}${this.duration[type].type}`;
      await M.api(M.entry("/put/duration"), this.payload);

      let typeText = this.payload.cert_duration_type === AUTH_SERVICE.ACTIVATED ? "고객 정품 인증일 기준" : "정품 인증 코드 생성일 기준";
      let dayText = `${this.duration[type].count} ${this.items.filter((item) => item.value === this.duration[type].type)[0].text}`;
      this.alertShow(`${typeText} ${dayText}</br> 으로 저장되었습니다.`);
    },
    /**
     * 셀렉트박스 변경시 카운트 초기화
     */
    initCount: function(type) {
      type.count = "";
    },
  },
  mounted: function() {},
};
</script>
